import * as api from "../api";

export const getConversations = async (convData, dispatch) => {
  try {
    const { data } = await api.getConversation(convData);
    return data;
    // dispatch({type: 'VALIDATED_USER', oldUser: data, message: 'Good to be back', messageType: 'success'});
  } catch (error) {
    // dispatch({type: "INCORRECT_CREDENTIALS", message: 'Incrorrect username or password', messageType: 'error'})
  }
};

export const getUsers = async (friendId, dispatch) => {
  try {
    const { data } = await api.getUsers(friendId);

    return data;
  } catch (error) {
    // dispatch({type: "INCORRECT_CREDENTIALS", message: 'Incrorrect username or password', messageType: 'error'})
  }
};
export const getAllUsers = async () => {
  try {
    const { data } = await api.getAllUsers();

    return data;
  } catch (error) {
    // dispatch({type: "INCORRECT_CREDENTIALS", message: 'Incrorrect username or password', messageType: 'error'})
  }
};

export const getMessages = async (convId) => {
  try {
    const { data } = await api.getMessages(convId);
    return data;
  } catch (error) {}
};
export const addMessage = async (message) => {
  try {
    const { data } = await api.addMessage(message);
    return data;
  } catch (error) {}
};
export const createConversation = async (dataId) => {
  try {
    const { data } = await api.createConversation(dataId);
    return data;
  } catch (error) {}
};
